import { Box, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import SelectGuestsSkeleton from "components/selection-components/select-guests-skeleton";
import { useBookingStateContext } from "hooks/use-booking-state";
import { usePageTracking } from "logger/use-page-tracking";
import { PageType } from "logger/page-tracking";
import { SelectRequestGuests } from "components/booking-request/booking-request-guests";
import { BookingRequestDate } from "components/booking-request/booking-request-date";

export default function BookingRequestWizard() {
    const externalBookingSettings = useExternalBookingSettings();
    const { guests } = useBookingStateContext();

    usePageTracking({
        pageName: "BookingRequestWizard",
        pageType: PageType.WizardStep,
        metadata: {
            hasGuests: Boolean(guests),
            activateWebChildren: externalBookingSettings.data?.unitsMetaData.activateWebChildren,
        },
    });

    if (externalBookingSettings.isLoading) return <SelectGuestsSkeleton />;
    if (!externalBookingSettings.data) return <SelectGuestsSkeleton />;

    return (
        <Box
            px={ThemeSpaceVariable.Medium}
            // @ts-expect-error // ! TODO: Add an extra media query variable for really small mobile screens
            sx={{
                "@media (max-width: 320px)": {
                    px: ThemeSpaceVariable.Small,
                },
            }}
        >
            {!guests ? <SelectRequestGuests /> : <BookingRequestDate />}
        </Box>
    );
}
